declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

const GA_SCRIPT_ID = 'ga4-script'
const GA_PLACEHOLDER_ID = 'G-PLACEHOLDER'

function getMeasurementId(): string | undefined {
  const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID?.trim()
  if (!measurementId || measurementId === GA_PLACEHOLDER_ID) return undefined
  return measurementId
}

export function initAnalytics(): void {
  const measurementId = getMeasurementId()
  if (!measurementId) return
  if (document.getElementById(GA_SCRIPT_ID)) return

  window.dataLayer = window.dataLayer || []
  window.gtag = (...args: unknown[]) => {
    window.dataLayer?.push(args)
  }
  window.gtag('js', new Date())
  window.gtag('config', measurementId, { send_page_view: false })

  const script = document.createElement('script')
  script.id = GA_SCRIPT_ID
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`
  document.head.appendChild(script)
}

export function trackPageView(path: string): void {
  const measurementId = getMeasurementId()
  if (!measurementId || !window.gtag) return

  window.gtag('event', 'page_view', {
    page_location: `${window.location.origin}${path}`,
    page_path: path,
    page_title: document.title,
    send_to: measurementId,
  })
}

export {}
